export default {
	error: state => state.app.error,
	loading: state => state.app.loading,
}